import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable, catchError, throwError } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../store/state';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AuthActions, GetUserActions } from '../store/actions';
import { Router } from '@angular/router';
import { SpinnerService } from '../services/spinner.service';

@UntilDestroy()
@Injectable()
export class LicenseInterceptor implements HttpInterceptor {
  constructor(
    private store: Store<AppState>,
    private router: Router,
    private spinnerService: SpinnerService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 403) {
          this.store.dispatch(GetUserActions.getUserDetailsFailure({ error }));
          this.store.dispatch(AuthActions.setAccessRestricted({ restricted: true }));
          this.spinnerService.hide();
          this.router.navigate(['/access-restricted']);
          return EMPTY;
        } else if (error instanceof HttpErrorResponse && error.status === 402) {
          this.store.dispatch(AuthActions.setLicenseExpired({ expired: true }));
          return EMPTY;
        } else {
          return throwError(() => error);
        }
      }),
    );
  }
}
